<template>
  <v-sheet
    color="white"
    elevation="5"
    rounded
    class="mt-5 mb-5 pt-3 pb-5 pl-3 pr-3"
  >
  <v-dialog v-model="showReportDialog">
      <report-viewer
        :reportName="Report_Name"
        :dataUrl="Report_URL"
        ref="reportViewer"
        :printOnly="true"
      />
    </v-dialog> 
    <div class="profile-content">
      <v-row>
        <v-col cols="8">
            <h4>{{dogInfo.dogPrefix}}</h4>
            <h1>{{ dogInfo.name }} - {{ dogId }}</h1>
            <h4>{{dogInfo.dogSuffix}}</h4>
        </v-col>
        <v-col cols="4">
          <v-btn class="ma-1" color="secondary" v-on:click="showNewPedigreeDialog()">Pedigree</v-btn>&nbsp;
          <v-btn class="ma-1" color="secondary" v-on:click="showRegCardDialog()">Registration Card</v-btn>&nbsp;<br/>
          <v-btn class="ma-1" color="secondary" v-on:click="showProgenyAdminDialog()">Progeny Report - Admin</v-btn>&nbsp;  
          <v-btn class="ma-1" color="secondary" v-on:click="showProgenyDialog()">Progeny Report - Member</v-btn>&nbsp;          
        </v-col></v-row>
      <v-divider class="my-3"></v-divider>
      <v-tabs v-model="tab">
        <v-tab key="registration"> Registration </v-tab>
        <v-tab key="showResults"> Show Results </v-tab>
        <v-tab key="titles"> Titles & Name</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item key="registration">
          <registration :dogId="dogId" />
        </v-tab-item>
        <v-tab-item key="showResults"> 
          <show-results :dogId="dogId" />
        </v-tab-item>
        <v-tab-item key="titles"> 
          <titles :dogId="dogId" :manualPrefix="dogInfo.dogPrefixManual" :manualSuffix="dogInfo.dogSuffixManual" :dogFullName="dogInfo.dogFullName" 
            v-bind:dogNamePrefix.sync="dogInfo.dogPrefix"
            v-bind:dogNameSuffix.sync="dogInfo.dogSuffix"
          /> 
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import Registration from "@/components/Admin/Details/Dogs/Registration.vue";
import ShowResults from "@/components/Admin/Details/Dogs/ShowResults.vue";
import Titles from "@/components/Admin/Details/Dogs/Titles.vue";
import ReportViewer from "@/components/Admin/Reports/ReportViewer.vue";

import dogService from "@/services/admin/dogService";

export default Vue.extend({
  name: "DogDetails",
  data: function () {
    return {
      dogInfo: {} as any,
      Report_Name: 'Asca.Api.Reports.rpt3210_Dog_Reg_Certificate.rdlx',
      Report_URL: '`/reports/registration/${dogId}`',
      showReportDialog: false,
      tab: null,
    };
  },  
  props: {
    dogId: { type: String },
  },
  components: {
    Registration,
    ShowResults,
    Titles,
    ReportViewer
  },
  methods: {
    showRegCardDialog: function (){   
      this.Report_Name = "Asca.Api.Reports.rpt3210_Dog_Reg_Certificate.rdlx";
      this.Report_URL = `/reports/registration/${encodeURIComponent(this.dogId.trim())}`;
      this.showReportDialog = true;
    },
    showNewPedigreeDialog: function (){
      this.Report_Name = "Asca.Api.Reports.rpt3240_Dog_Pedigree_Report_New2.rdlx";
      this.Report_URL = `/reports/pedigree/${encodeURIComponent(this.dogId.trim())}`;
      this.showReportDialog = true;
    },
    showProgenyAdminDialog: function (){
      this.Report_Name = "Asca.Api.Reports.rpt3250_Dog_Progeny_Report.rdlx";
      this.Report_URL = `/admin/reports/progeny/${encodeURIComponent(this.dogId.trim())}`;
      this.showReportDialog = true;
    },    
    showProgenyDialog: function (){
      this.Report_Name = "Asca.Api.Reports.rpt3250_Dog_Progeny_Report.rdlx";
      this.Report_URL = `/reports/progeny/${encodeURIComponent(this.dogId.trim())}`;
      this.showReportDialog = true;
    },  
  },
  created: function () {
    if(this.$props.dogId){
      dogService
        .getDogById(this.$props.dogId)
        .then((res) => {
          this.dogInfo = res;
        })
        .catch(this.$handleError);
    }
  },
  watch: {
    dogId: function (newVal: String) {
      if(newVal){
        dogService
          .getDogById(this.$props.dogId)
          .then((res) => {
            this.dogInfo = res;
          })
          .catch(this.$handleError);
      }
    },
  },
});
</script>
